import React, { useState, useEffect, Fragment } from "react";
import SubRow from "./SubRow";
import { Link, TableRow, TableCell, Checkbox, TextField } from '@mui/material';
import { getAllTestFromSet } from 'services';
import { useDispatch, useSelector } from 'react-redux';

let tempData: any = [];
let itemList: any = [];

const TableRowData = ({
    resultValue,
    selectedMatrixType,
    getPriceListId,
    locationId,
    isUpdate,
    isAvailableTest
}: any) => {
    const [data, setData] = useState([] as any[]);
    const dispatch = useDispatch();

    let dataList: any = useSelector((state: any) => state.dataList);
    let priceItems: any = useSelector((state: any) => state.priceItems);

    let filteredArr: any = priceItems?.filter(function (item, index) {
        if (priceItems.indexOf(item) === index)
            return item;
    });

    useEffect(() => {
        if (resultValue) {
            resultValue.map((i: any) => {
                i.isSelected = false;
            })
            setData(resultValue);
        }
    }, [resultValue])

    let refreshItem = isUpdate === 1 ? 'true' : 'false';
    let isError = isAvailableTest ? 'true' : 'false';

    useEffect(() => {
        if (dataList?.length === 0) {
            itemList = [];
        }
    }, [dataList])

    useEffect(() => {
        if (refreshItem) {
            itemList = [];
            tempData = [];
            setData(resultValue);
        }
    }, [refreshItem])

    useEffect(() => {
        if (isError) {
            parentLoop(data);
        }
    }, [isError])


    const updateState = (id: any, itemAttributes: any) => {
        let index = data.findIndex((x: any) => x.id === id);
        if (index !== -1) {
            let data1 = [
                ...data.slice(0, index),
                Object.assign({}, data[index], itemAttributes),
                ...data.slice(index + 1)
            ]
            setData(data1);
        }
    };

    const expandRow = (user: any) => {
        if (filteredArr?.length > 0) {
            nextedLoop(filteredArr, user);
        } else {
            innerChildCall(user);
        }
    };

    const nextedLoop = (item: any, user: any) => {
        let found: boolean = false;
        let selectedItem: any = {};
        for (let i = 0; i < item?.length; i++) {
            if (item[i].id === user?.id) {
                selectedItem = item[i];
                found = true;
                break;
            }
        }

        if (found) {
            user.children = selectedItem.data;
            user.id = selectedItem.id;
            updateState(user.id, { isExpanded: true });
            found = false;
        }
        else {
            innerChildCall(user);
        }

    }

    const innerChildCall = (user: any) => {
        user.children = [];
        getAllTestFromSet(selectedMatrixType, getPriceListId, locationId, user.associatedTests).then((res: any) => {
            if (res.status === 200) {
                let obj = {
                    'associatedTests': user.associatedTests,
                    'data': res.data,
                    'id': user.id
                }
                if (tempData.length > 0) {
                    const index = tempData.findIndex((object: any) => object.id === user.id);
                    if (index === -1) {
                        tempData.push(obj);
                        dispatch({ type: 'PRICE_LIST', payload: tempData });
                    }
                } else {
                    tempData.push(obj);
                    dispatch({ type: 'PRICE_LIST', payload: tempData });
                }

                tempData.map((i: any) => {
                    if (i.id === user.id) {
                        user.children = i.data;
                    }
                })
                updateState(user.id, { isExpanded: true });
            }
        });
    }

    const collapseRow = (user: any) => {
        user.children = undefined;
        updateState(user.id, { isExpanded: false });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, val: any) => {
        dispatch({ type: 'ADD_DATA', payload: [] });
        val.isSelected = event.target.checked;
        if (event.target.checked) {
            if (itemList?.length > 0) {
                itemList?.map((item: any) => {
                    if (val.id !== item.id) {
                        itemList.push(val);
                    }
                    filterArray(filteredArr, val, true);
                })
            } else {
                itemList.push(val);
            }
            let filteredItems: any = filterArrayElement(itemList);
            dispatch({ type: 'ADD_DATA', payload: filteredItems });
        } else {
            for (let i = 0; i < itemList?.length; i++) {
                if (itemList[i].id === val.id) {
                    itemList[i].isSelected = false;
                    itemList.splice(i, 1);
                    break;
                }
                filterArray(filteredArr, val, false);
            }
            let filteredItems: any = filterArrayElement(itemList);
            dispatch({ type: 'ADD_DATA', payload: filteredItems });
        }
    };

    const filterArray = (item: any, val: any, status: any) => {
        return item.map((i: any) => {
            if (i.id === val.id) {
                i.isSelected = status;
            }
        })
    }

    const filterArrayElement = (val: any) => {
        let newArray: any = [];
        let uniqueObject: any = {};
        let i: any;

        for (i in val) {
            let objId = val[i]['id'];
            uniqueObject[objId] = val[i];
        }

        for (i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }

        return newArray;
    }

    const handleNumberOfSample = (event: any, index: any, user: any, type: any) => {
        let newArray = [...data];
        if (type === 'noOfSamples') {
            newArray[index] = {
                ...newArray[index],
                noOfSamples: parseInt(event.target.value)
            };
            user.noOfSamples = parseInt(event.target.value);
        } else {
            newArray[index] = {
                ...newArray[index],
                testPrice: parseInt(event.target.value)
            };
            user.testPrice = parseInt(event.target.value);
        }
        setData(newArray);
        tempArray(newArray, user);
    }

    const tempArray = (arr: any, user: any) => {
        let obj = {
            'associatedTests': user.associatedTests,
            'data': arr,
            'id': user.id
        }
        tempData.push(obj);
        dispatch({ type: 'PRICE_LIST', payload: tempData });
    }

    const parentLoop = (data: any) => {
        data.map((i: any) => {
            i.isSelected = false;
            if (i.children > 0) {
                childLoop(i.children);
            }
        })
    }

    const childLoop = (child: any) => {
        child.map((j: any) => {
            j.isSelected = false;
            if (j.children > 0) {
                childLoop(j.children);
            }
        })
    }

    if (data) {
        const appData = data.map((user: any, index: any) => {
            return (
                <Fragment key={user.id}>
                    <TableRow tabIndex={-1} key={user.index}>
                        <TableCell style={{ padding: '4px' }}>
                            <Checkbox
                                onChange={(event: any) => handleChange(event, user)}
                                checked={user?.isSelected}
                                name="rowSelected"
                            />
                        </TableCell>
                        <TableCell style={{ padding: '4px' }}>
                            {user?.associatedTests?.length > 0 ? <Link
                                component="button"
                                variant="body2"
                                onClick={() => {
                                    if (user?.children?.length > 0) {
                                        collapseRow(user);
                                    } else {
                                        expandRow(user);
                                    }
                                }}
                            >
                                {user.code}
                            </Link> : <>{user.code}</>}
                        </TableCell >
                        <TableCell style={{ padding: '4px' }}>{user.testName}</TableCell>
                        <TableCell style={{ padding: '4px' }}>{user.matrixType}</TableCell>
                        <TableCell style={{ padding: '4px' }}>{user.methodReference}</TableCell>
                        <TableCell style={{ padding: '4px' }}>{user.lor}</TableCell>
                        <TableCell style={{ padding: '4px' }}>{user.isSubContracted ? `Yes - ${user.subContractorName}` : 'No'}</TableCell>
                        <TableCell style={{ padding: '4px' }}>{user.nataCertified ? 'Yes' : 'No'}</TableCell>
                        <TableCell style={{ padding: '4px' }}>
                            <TextField
                                id="outlined-basic"
                                type="number"
                                name="noOfSamples"
                                label=""
                                sx={{
                                    '.MuiOutlinedInput-input': {
                                        width: '75px',
                                        padding: '8px 10px',
                                        fontSize: '12px'
                                    }
                                }}
                                variant="outlined"
                                size="small"
                                value={user.noOfSamples}
                                onChange={(event: any) => handleNumberOfSample(event, index, user, 'noOfSamples')}
                            />
                        </TableCell>
                        <TableCell style={{ padding: '4px' }}>
                            <TextField
                                id="outlined-basic"
                                type="number"
                                label=""
                                name="testPrice"
                                variant="outlined"
                                sx={{
                                    '.MuiOutlinedInput-input': {
                                        width: '75px',
                                        padding: '8px 10px',
                                        fontSize: '12px'
                                    }
                                }}
                                size="small"
                                value={user.testPrice}
                                onChange={(event: any) => handleNumberOfSample(event, index, user, 'testPrice')}
                            />
                        </TableCell>
                        <TableCell style={{ padding: '4px' }}>{(user.noOfSamples * user.testPrice).toFixed(2)}</TableCell>
                    </TableRow>
                    {user?.children?.length > 0 &&
                        <SubRow
                            rowData={user.children}
                            handleChange={handleChange}
                            selectedMatrixType={selectedMatrixType}
                            getPriceListId={getPriceListId}
                            locationId={locationId}
                            isUpdate={isUpdate}
                            parentLoop={parentLoop}
                        />}
                </Fragment>
            );
        });
        return <Fragment>{appData}</Fragment>;
    } else {
        return null;
    }
}

export default TableRowData;
